import { useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';

import { useEvents } from '../EventManager/index.js';

import 'react-toastify/dist/ReactToastify.css';

/**
 * Notifier component listens to error and notification events and displays them
 * as toasts
 */
export const Notifier = () => {
  const events = useEvents();

  useEffect(() => {
    const errorHandler = (err: string) => {
      toast.error(err);
    };

    const notificationHandler = (message: string) => {
      toast.success(message);
    };

    events.on('error', errorHandler);
    events.on('notification', notificationHandler);

    return () => {
      events.off('error', errorHandler);
      events.off('notification', notificationHandler);
    };
  }, [events]);

  return <ToastContainer hideProgressBar pauseOnHover />;
};
